// libs
import { styled } from '@nykaa/ui-components';

// component
import Wishlist from 'shared/components/Wishlist';

// global components
import BaseImage from 'shared/components/ImageV2';

//constants

export const Container = styled.div<{ borderColor: string }>`
  position: relative;
  ${({ borderColor }) => borderColor && `border: 1px solid ${borderColor};`};
  ${({ theme }) => `margin: ${theme.spacing.spacing50} 0;`};
  ${({ theme }) => `border-radius: ${theme.borders.radius20};`};
`;

export const SaleBanner = styled.div<{ headerColor: string }>`
  ${({ headerColor }) => headerColor && `background: ${headerColor};`};
  height: auto;
  display: flex;
  justify-content: center;
`;

export const Image = styled(BaseImage)`
  background-color: transparent;
`;

export const Info = styled.div<{ bgColor: string }>`
  ${({ bgColor }) => bgColor && `background: ${bgColor};`};
  ${({ theme }) => `padding-bottom: ${theme.spacing.spacing60};`};
`;

export const InfoDesktop = styled(Info)`
  padding: ${({ theme }) => theme.spacing.spacing80} ${({ theme }) => theme.spacing.spacing120}
    ${({ theme }) => theme.spacing.spacing120};
  display: flex;
  justify-content: space-between;
`;

export const PriceDetails = styled.div`
  text-align: center;
  ${({ theme }) => `padding-top: ${theme.spacing.spacing20};`};
`;

export const PriceDetailsDesktop = styled(PriceDetails)`
  text-align: left;
  padding-top: 0;
`;

export const Amount = styled.span<{ color: string }>`
  ${({ color }) => color && `color: ${color};`};
  ${({ theme }) => theme.typography.titleMedium};
`;

export const Currency = styled.span`
  ${({ theme }) => `margin-right: ${theme.spacing.spacing10};`};
`;

export const Discount = styled.span<{ color: string }>`
  ${({ theme }) => theme.typography.subTitleMedium};
  ${({ theme }) => `margin-left: ${theme.spacing.spacing20};`};
  ${({ color }) => color && `color: ${color};`};
`;

export const Data = styled.div<{ color: string }>`
  text-align: center;
  ${({ theme }) => theme.typography.bodySmall};
  ${({ color }) => color && `color: ${color};`};
`;
export const DataDesktop = styled(Data)`
  margin-top: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.bodyMedium};
  text-align: left;
`;

export const WishlistButtonContainer = styled(Wishlist)`
  ${({ theme }) => `height: ${theme.spacing.spacing160};`};
  ${({ theme }) => `margin: 0 ${theme.spacing.spacing60};`};
  ${({ theme }) => `background: ${theme.colors.surface};`};
  ${({ theme }) => `margin-top: ${theme.spacing.spacing20};`};
  ${({ theme }) => `border: 1px solid ${theme.colors.textOutline};`};
  ${({ theme }) => `border-radius: ${theme.borders.radius10};`};
  cursor: pointer;
`;

export const WishlistButtonContainerDesktop = styled(WishlistButtonContainer)`
  height: 48px;
  width: max-content;
  min-width: 184px;
  padding: ${({ theme }) => theme.spacing.spacing80};
  margin-left: 0;
  margin-right: 0;
`;
